import {CSSProperties} from "react";
import {Clickable, Style} from "interfaces";
import styled, {useTheme} from "styled-components";

const Image = styled.img`
  object-fit: contain;
  width: 35px;
  height: 35px;
`;

interface BrandProps extends Style, CSSProperties, Partial<Clickable> {}

export const Brand: React.FC<BrandProps> = ({style, onClick, ...cssStyle}) => {
  const {isDark} = useTheme();
  return (
    <Image
      alt="logo"
      onClick={onClick}
      style={{...cssStyle, ...style}}
      src={isDark ? "/images/logo-yellow.png" : "/images/logo.png"}
    />
  );
};
